import React from 'react';

export const TriangleBlueIcon = ({ ...props }) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.11917 5.44731C9.15084 5.39864 9.16667 5.34564 9.16667 5.29264C9.16667 5.22598 9.14167 5.15998 9.0925 5.10298L5.34242 0.769643C5.2645 0.679643 5.13658 0.625977 4.99991 0.625977C4.86324 0.625977 4.73532 0.679643 4.6574 0.769643L0.907322 5.10298C0.819403 5.20464 0.808986 5.33764 0.880654 5.44731C0.952739 5.55731 1.09483 5.62598 1.24983 5.62598L8.74999 5.62598C8.905 5.62598 9.04708 5.55731 9.11917 5.44731Z"
      fill="#27B0E0"
    />
  </svg>
);
